<template>
  <div class="ranking-page">
    <div class="ranking-header">
      <div class="ranking-banner">
        <img class="img" src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/tangjiu/113/ranking/top.png" alt="">
      </div>
    </div>
    <div class="ranking-content">
      <div class="ranking-item" v-for="(item, index) in rankingList" :key="item.id">
        <div class="left">
          <div v-if="index < 3" class="crown">
            <img class="img" :src="`https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/tangjiu/113/ranking/ranking_${index + 1}.png`" alt="">
          </div>
          <div v-else class="circle">
            <span>{{item.rank}}</span>
          </div>
        </div>
        <div class="right">
          <div class="company ellipsis-1">{{item.name}}</div>
          <div class="cicount"></div>
        </div>
      </div>
    </div>
    <div class="ranking-footer">
      <img class="img" src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/tangjiu/113/ranking/bottom.png" alt="">
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        rankingList: []
      }
    },
    created() {
      this.$store.commit('changeToken', 'PBB+hfqyCn5u/Asp+KqEamDzT9M4NOO+mCcaaBwVVxXGqTTtK0xlBOZ/bJUKrMMz28h7C5vjrRJ30KG/ez8kw+nyL21LlTbHE7s9DAcaZf2vHp6SUZ+hxMZD+Vx4OVSs8/lzo80KxYaPNqn7kEkK/+LSwFtdL1M6zInwAke1rj9Yj2yg+UIAhUXei6AoGxxd7h18E1SncYIPukUmWlVAsHzhxLGBP9tOeJdS6oZ4RYKXIeoSHtEZefeF/0Ne5PpFdZjPGeTCeSLhi0QVNZ+70jSDR0ZiOfQJ5NTNtnT9EOJMGGPZkoevYDS/Wd1LcvI5xPT8hle8hE3TgEdYGc2Z+P4TQ3pEta1RRke+boQK/qNYu1LJkzJtNYIDRsf1bshJFAf5AxjrLvNiDx1pKcwNfgT1w5M/Dvv5yMKwTbI5yGQ=')

      this.getRankingList()
    },
    methods: {
      async getRankingList() {
        const res = await this.$http.getCollectionRankList({ exhibitionId: "33daa57b2a73433eab29bbc04ec37650", top: 30 })
        if (res.code === 1000) {
          this.rankingList = res.data
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ranking-page {
    background: #EA592A;
  }
  .ranking-header {
    padding: 20px 16px 0;
  }
  .ranking-banner {
    width: 100%;
    .img {
      width: 90%;
      margin: 0 auto;
      display: block;
    }
  }
  .ranking-content {
    padding: 16px 16px 0;
    min-height: 411px;
    .ranking-item {
      padding: 8px 7px 8px;
      background: url("https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/tangjiu/113/ranking/box.png");
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      .left {
        width: 26px;
        height: 26px;
        display: flex;
        align-items: center;
        justify-content: center;
        .crown {
          width: 100%;
          height: 100%;
          .img {
            width: 100%;
            height: 100%;
          }
        }
        .circle {
          width: 18px;
          height: 18px;
          border-radius: 50%;
          border: 1px solid #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;
          span {
            font-size: 12px;
            color: #ffffff;
          }
        }
      }
      .right {
        flex: 1;
        padding: 0 15px;
        overflow: hidden;
        .company {
          font-weight: 600;
          font-size: 15px;
          color: #FFFFFF;
        }
      }
    }
  }
  .ranking-footer {
    width: 100%;
    .img {
      width: 100%;
      display: block;
    }
  }
</style>